import { useTranslation } from 'react-i18next';

import { Dialog, HtmlPreview } from '~/components';

import { previewDialogStyle } from './QuotationPreviewDialog.css';

type Props = {
  html: string | undefined;
  onClose: () => void;
  title: null | string;
};

export const QuotationPreviewDialog = ({ html, onClose, title }: Props) => {
  const { t } = useTranslation(['quotations']);

  return (
    <Dialog.Root onOpenChange={(open) => !open && onClose()} open={html !== undefined}>
      <Dialog.Body className={previewDialogStyle}>
        <Dialog.Header title={title || undefined} />

        {html !== undefined && <HtmlPreview html={html} title={title || t('quotations:overview.rowActions.preview')} />}
      </Dialog.Body>
    </Dialog.Root>
  );
};
